import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";

class Contact extends Component {
  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const street = this.props.data.address.street;
    const city = this.props.data.address.city;
    const state = this.props.data.address.state;
    const zip = this.props.data.address.zip;
    const phone = this.props.data.phone;
    const message = this.props.data.contactmessage;

    return (
      <section id="contact">
        <Fade bottom duration={1000}>
          <div className="row section-head">
            <div className="two columns header-col">
              <h1>
                <span>Get In Touch.</span>
              </h1>
            </div>

            <div className="ten columns">
              <p className="lead">{message}</p>
            </div>
          </div>
        </Fade>

        <div className="row">
          <Slide left duration={1000}>
            <div className="eight columns">
              <form action="" method="post" id="contactForm" name="contactForm">
                <fieldset>
                  <div>
                    <label htmlFor="contactName">
                      Nombre <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="contactName"
                      name="contactName"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="contactEmail">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="contactEmail"
                      name="contactEmail"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="contactSubject">No. de contacto</label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="contactSubject"
                      name="contactSubject"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="contactMessage">
                      Mensaje <span className="required">*</span>
                    </label>
                    <textarea
                      cols="50"
                      rows="15"
                      id="contactMessage"
                      name="contactMessage"
                    ></textarea>
                  </div>

                  <div>
<button
  className="submit"
  onClick={async (e) => {
    e.preventDefault();

    // Construir el cuerpo del request
    const payload = {
      name: document.getElementById("contactName").value,
      email: document.getElementById("contactEmail").value,
      phone: document.getElementById("contactSubject").value,
      message: document.getElementById("contactMessage").value,
    };

    try {
      // Invocar el endpoint de AWS
      const response = await fetch("https://0ef3yy4mm5.execute-api.us-east-2.amazonaws.com/emailfolder", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      // Leer respuesta
      const data = await response.json();
      console.log("✅ Respuesta de AWS:", data);

      alert("Mensaje enviado correctamente ✅");
    } catch (error) {
      console.error("❌ Error al enviar:", error);
      alert("Error al enviar el mensaje ❌");
    }
  }}
>
  Confirmar
</button>

<span id="image-loader">
  <img alt="" src="images/loader.gif" />
</span>
                  </div>
                </fieldset>
              </form>

              <div id="message-warning"> Error boy</div>
              <div id="message-success">
                <i className="fa fa-check"></i>Tu mensaje y registro fue enviado, gracias
                <br />
              </div>
            </div>
          </Slide>

          <Slide right duration={1000}>
            <aside className="four columns footer-widgets">
              <div className="widget widget_contact">
                <h4>Dirección y teléfono de contacto</h4>
                <p className="address">
                  {name}
                  <br />
                  {street} <br />
                  {city}, {state} {zip}
                  <br />
                  <span>{phone}</span>
                </p>
              </div>

              <div className="widget widget_tweets">
                <h4 className="widget-title">Comentarios sobre el registro</h4>
                <ul id="twitter">
                  <li>
                    <span>
                      Al compartirnos sus datos a través de este formulario estaremos contactándolo prontamente.
                       </span>
                    <b>
                      <a href="./">FIIPEP</a>
                    </b>
                  </li>
                  <li>
                    <span>
                      Al ingresar sus datos usted acepta el tratamiento de datos por parte de la fundación FIIPEP.
                     
                    </span>
                    <b>
                      <a href="./">FIIPEP</a>
                    </b>
                  </li>
                </ul>
              </div>
            </aside>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Contact;
